document.addEventListener("click", function (e) {
	const btn = e.target.closest(".tst-link-to-event-button__btn");
	if (!btn) return;
	const href = btn.getAttribute("data-href");
	if (href) window.location.href = href;
});

document.addEventListener("keydown", function (e) {
	if (e.key !== "Enter" && e.key !== " ") return;
	const btn = document.activeElement;
	if (!btn || !btn.classList.contains("tst-link-to-event-button__btn")) return;
	e.preventDefault();
	const href = btn.getAttribute("data-href");
	if (href) window.location.href = href;
});
